<script>
  import { authModule } from "@/stores/auth.js";
  import { mapStores } from 'pinia'

  export default {
    name: "mainNav",

    data() {
      return {
        intervalId: null,
        refreshInterval: 5 * 60 * 1000,
        // `hidden` is the permission that removes the item; a missing entry is always shown.
        items: [
          { label: 'Dashboard',    to: '/',            match: null,          icon: 'mdi-view-dashboard-outline', hidden: null },
          { label: 'Clients',      to: '/client',      match: 'client',      icon: 'mdi-account-group-outline',  hidden: 'CLIENT_HIDDEN' },
          { label: 'Packages',     to: '/package',     match: 'package',     icon: 'mdi-package-variant-closed', hidden: 'PACKAGE_HIDDEN' },
          { label: 'Pre-Alerts',   to: '/pre-alerts',  match: 'pre-alert',   icon: 'mdi-bell-ring-outline',      hidden: 'PREALERT_HIDDEN' },
          { label: 'Report',       to: '/report',      match: 'report',      icon: 'mdi-chart-box-outline',      hidden: 'REPORT_HIDDEN' },
          { label: 'Transactions', to: '/transaction', match: 'transaction', icon: 'mdi-swap-horizontal',        hidden: 'TRANSACTION_HIDDEN' }
        ]
      }
    },
    mounted() {
      this.intervalId = setInterval(() => {
        this.authStore.fetchProfile();
      }, this.refreshInterval);
    },
    beforeUnmount() {
      clearInterval(this.intervalId);
    },
    computed: {
      ...mapStores(authModule),
      visibleItems() {
        if (!this.authStore.isLoggedIn) return []
        const permissions = this.authStore.userObj?.permissions || []
        return this.items.filter(i => !i.hidden || !permissions.includes(i.hidden))
      }
    },
    methods: {
      isActive(item) {
        return item.match ? this.$route.path.includes(item.match) : this.$route.path === '/'
      }
    }
  }
</script>

<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg">
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav">
            <li class="nav-item" v-for="item in visibleItems" :key="item.to">
              <router-link class="nav-link" :class="{ active: isActive(item) }" :to="item.to">
                <i class="mdi me-1" :class="item.icon"></i>{{ item.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
